import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=3f141f75&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"
import style0 from "./purchase.vue?vue&type=style&index=0&id=3f141f75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f141f75",
  null
  
)

export default component.exports